// Máscara para campos do tipo RCPJ (Registro Civil das Pessoas Jurídicas)
angular.module("avlib").directive("avRcpjMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var formatRcpj = function(value){
				if (value == null || value == ""){
					ctrl.$setValidity("rcpj", true);
					return value;
				}
				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				if (value.length > 6){
					value = value.substr(0,6);
				}
				ctrl.$setValidity("rcpj", value.length == 6);
				return value;
			};

			var rcpjParser = function(viewValue){
				var formattedRcpj = formatRcpj(viewValue);
				ctrl.$setViewValue(formattedRcpj);
				ctrl.$render();
				return parseInt(formattedRcpj.replace(/\D/g,''));
			};

			var rcpjFormatter = function(viewValue){
				if (viewValue != null){
					var modelValue = (""+viewValue).replace(/\D/g,'')
					while (modelValue.length < 6) {modelValue = "0" + modelValue;}
					ctrl.$modelValue = modelValue;
					return formatRcpj(modelValue);
				}
			};

			ctrl.$parsers.push(rcpjParser);
			ctrl.$formatters.push(rcpjFormatter);
		}
	};
});
